
import React from 'react'
import { BreathAPIs } from '../../../APIs/BreathAPIs';
import { useEffect, useState, useContext } from 'react'
import { connect, useSelector } from 'react-redux'
import PropTypes from 'prop-types'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBolt } from '@fortawesome/free-solid-svg-icons';
import { BookingsContext } from './BookingContext';
import styles from "./style.module.css"
import { ButtonCustom } from '../../../BootstrapComponents/ButtonCustom';
import { toast } from 'react-toastify';
import { FaInfoCircle } from "react-icons/fa";
import { CgUnavailable } from "react-icons/cg";
import { Flex, Radio } from 'antd';
import Animations from '../../../Animations/Animations';
import { FaChargingStation } from 'react-icons/fa6';

import { useWebSocket } from '../../../Utils/WebSocketContext';
import { useStripe } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import Helper from '../../../Utils/Helper';
import StripePayment from '../../../StripePayment/StripePayment';
import {Modal} from 'antd';
import { PiPlugChargingFill } from "react-icons/pi";
import { loadUser } from '../../../Actions/Auth';
import store from '../../../store';
import PhoneVerificationModal from '../../../RegistrationCommponents/PhoneVerificationModal';
import GuestBookingPayment from '../../../StripePayment/GuestBookingPayment';
import HourMinuteSelector from '../../../BookingHistory/components/BookingExtension/components/HourMinuteSelector';


const BookingFormNonRes = ({ user, userID, userGroups, usersFreeChargingLocations, location, balance, selectedLocation, handleNewBooking, selectedTime, makeToast, costPerMinute, isUserTester, isAutoPayEnabled, timeFormatAmPm, extraTimeList, setExtraTimeList, quickStart, locationData, bookedSlots, selectedChargerForNonRes = null, isPhoneVerified, phone, userAvgPower, isGuest }) => {

  const [isBookingNonRes, setIsBookingNonRes] = useState(selectedChargerForNonRes ? (selectedChargerForNonRes.nonReservable ? true : false) : false)
  // console.log("selectedChargerForNonRes: ", selectedChargerForNonRes)
  const[phoneState, setPhoneState] = useState(phone)
  const[isPhoneVerifiedState, setIsPhoneVerifiedstate] = useState(isPhoneVerified)
  const [showPhoneVerificationModal , setShowPhoneVerificationModal]= useState(false)
  const [guestPaymentBooking, setGuestPaymentBooking] = useState(null)
  const { isLoading, isAuthenticated } = useSelector(state => state.auth)
  const [chargers, setChargers] = useState([]);
  const [bookings, setBookings] = useState([]);
  const [availableChargers, setAvailableChargers] = useState([]);
  const [availableFreeChargers, setAvailableFreeChargers] = useState([]);
  const [selectedCharger, setSelectedCharger] = useState("");
  const [startDate, setStartDate] = useState("");
  const [startTime, setStartTime] = useState("");
  const [duration, setDuration] = useState("");
  const [amountToAdd, setAmountToAdd] = useState(10);
  const [durationReFill, setDurationReFill] = useState(0);

  const [startInstantly, setStartInstantly] = useState(false);
  const [instantTime, setInstantTime] = useState(null);

  // const [extraTimeList, setExtraTimeList] = useState([]);
  const [startTimeDisplay, setStartTimeDisplay] = useState('');
  const [startTimeDisplayChargerTime, setStartTimeDisplayChargerTime] = useState('');
  const [startDateDisplayChargerTime, setStartDateDisplayChargerTime] = useState('');
  const [endTimeDisplay, setEndTimeDisplay] = useState('');
  const [endTimeDisplayChargerTime, setEndTimeDisplayChargerTime] = useState('');

  const [trigger, setTrigger] = useState(false);

  const [moreInfo, setMoreInfo] = useState(false);

  // const [isFreeBooking, setFreeBooking] = useState(false);

  const [isSubmitting, setIsSubmitting] = useState(false);

  const [lockedAmount, setLockedAmout] = useState(0);

  const { bookingsData, refetchBookings, isBookingLoading, chargersData } = useContext(BookingsContext);

  const [currentTimeOne, setCurrentTimeOne] = useState(new Date());

  const [bookingSlotAvailability, setBookingSlotAvailability] = useState(true)

  const [minimumBalanceAvailable, setMinimumBalanceAvailable] = useState(true)

  const [renderTickMark, setRenderTickMark] = useState(false)

  const [estimateAmount, setEstimateAmount] = useState(0);

  const [dynamicRanges, sestDynamicRanges] = useState([]);

  const [rateType, setRateType] = useState("fixed")

  const [normalRate, setNormalRate] = useState(0)

  const [estimateSplit, setEstimateSplit] = useState('')

  const [isFreeChargingForSelectedLocation, setIsFreeChargingForSelectedLocation] = useState(false)
  const [isCustomEnergyRateForSelectedLocation, setIsCustomEnergyRateForSelectedLocation] = useState(false)
  const [customEnergyRate, setCustomEnergyRate] = useState(0)

  const [bookingSlotConflictShared, setBookingSlotConflictShared] = useState(false)

  const [nonResBookingAllowed, setNonResBookingAllowed] = useState(false)

  const [walletRechargeModal, setWalletRechargeModal] = useState(false);

  const [eventType, setEventType] = useState(null);
  
  const [connectorStatus, setConnectorStatus] = useState(selectedChargerForNonRes ? selectedChargerForNonRes.status : null);

  const [idleFee, setIdleFee] = useState(selectedLocation && locationData.length > 0 ?
      locationData.map(loc => loc._id === selectedLocation ? loc.idleFee : 0)
      : 0);

   const webSocket = useWebSocket();



  function isFreeChargingAllowedInSelectedLocation(locationsFromPermission = []) {

    if (usersFreeChargingLocations.includes(selectedLocation)) {

      return true
    }
    if (locationsFromPermission.includes(selectedLocation)) {
      return true
    }
    // }
    if (usersFreeChargingLocations.length === 0 && locationsFromPermission.length === 0) {
      return true
    }
    return false;
  }

  function isCustomEnergyRateEnabledInSelectedLocation(customEnergyRateEnabledLocations = null) {
    try {
      if (customEnergyRateEnabledLocations) {
        if (customEnergyRateEnabledLocations.length === 0) {
          return true
        } else {
          if (customEnergyRateEnabledLocations.includes(selectedLocation)) {
            return true
          } else {
            return false
          }
        }
      }
    } catch (error) {
      console.log(error.message)
    }

  }

  useEffect(() => {
      setIdleFee(selectedLocation && locationData.length > 0 ?
        locationData.map(loc => loc._id === selectedLocation ? loc.idleFee : 0)
        : 0)
    }, [selectedLocation])

  useEffect(()=>{
    if (webSocket) {
      console.log("WebSocket connection established for BookingFormNonRes component.")
      webSocket.addEventListener('message', function (event) {
        // console.log("WebSocket event received: ", event.data)
        setEventType(JSON.parse(event.data).type)             //charger diff 
        if (JSON.parse(event.data).type === "chargestation.connector_status.updated") { // Connector status Charging.
          for (let i = 0; i < JSON.parse(event.data).data.connectors.length; i++) {
            if (selectedChargerForNonRes.connectorID === JSON.parse(event.data).data.connectors[i].meta_data.breatheConnectorId) {
              setConnectorStatus(JSON.parse(event.data).data.connectors[i].status)

              console.log("Connector status updated: ", JSON.parse(event.data).data.connectors[i].status)
            }
          }

        }
      });
    }
  },[webSocket])  
  useEffect(() => {

    setIsFreeChargingForSelectedLocation(false)
      try {
        userGroups.filter((userGroup) => {
          try {

            let parsedPermissions = JSON.parse(userGroup.permissions)

            try {
              if (parsedPermissions?.freeCharging && parsedPermissions?.freeCharging === 'allowed') {
                let isFreeCharging;

                if ("freeChargingAllowedLocations" in parsedPermissions) {
                  isFreeCharging = isFreeChargingAllowedInSelectedLocation(parsedPermissions.freeChargingAllowedLocations)
                } else {
                  isFreeCharging = isFreeChargingAllowedInSelectedLocation()
                }
                isFreeCharging ? setIsFreeChargingForSelectedLocation(true) : setIsFreeChargingForSelectedLocation(false)

              }
            } catch (error) {
              console.log(error.message)
            }

          try {
            if (parsedPermissions?.customEnergyRate && parsedPermissions?.customEnergyRate === 'enabled') {
              let isCustomEnergyRateEnabled = false
              if ("customEnergyRateEnabledLocations" in parsedPermissions) {
                isCustomEnergyRateEnabled = isCustomEnergyRateEnabledInSelectedLocation(parsedPermissions.customEnergyRateEnabledLocations)
              } else {
                isCustomEnergyRateEnabled = true
              }


              if (isCustomEnergyRateEnabled) {
                setIsCustomEnergyRateForSelectedLocation(true)
                setCustomEnergyRate(parsedPermissions?.customEnergyRateEnabledRate)
              } else {
                setIsCustomEnergyRateForSelectedLocation(false)
                setCustomEnergyRate(0)
              }
            }

          } catch (error) {
            console.log(error.message)
          }


        } catch (error) {
          console.log(error.message)
        }

      })
    } catch (error) {
      console.log(error.message)
    }

  }, [startTime])

  const localTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  const locationTimezone = locationData[0]?.timezone;;
  const [showChargerTime, setShowChargerTime] = useState(false);



//   useEffect(() => {
//     let offset = getTimeZoneOffsetTwoTimezone(localTimezone, locationTimezone)
//     if (offset !== 0) {
//       setShowChargerTime(true);
//     }
//     else {
//       setShowChargerTime(false);
//     }
//   }, [locationTimezone]);

  function getTimeZoneOffsetTwoTimezone(timeZone1, timeZone2, date = new Date()) {
    // Create a date object for both time zones
    const dateInTimeZone1 = new Date(date.toLocaleString('en-US', { timeZone: timeZone1 }));
    const dateInTimeZone2 = new Date(date.toLocaleString('en-US', { timeZone: timeZone2 }));
    // Get the difference in time in milliseconds
    const timeDifferenceInMilliseconds = dateInTimeZone2.getTime() - dateInTimeZone1.getTime();

    return timeDifferenceInMilliseconds;
  }

//   useEffect(() => {
//     if (duration && selectedCharger) {

//       let returnVal = calculateEstimatedAmount();
//       isFreeChargingForSelectedLocation ? setEstimateAmount(0) : setEstimateAmount(returnVal.estimateAmount);
//       isCustomEnergyRateForSelectedLocation ? sestDynamicRanges([]) : sestDynamicRanges(returnVal.applicableDynamicRanges);
//       setRateType(returnVal.rateType);
//       setNormalRate(returnVal.normalRate)
//     }
//   }, [duration, selectedCharger])

  useEffect(() => {
    const interval = setInterval(() => {
      const now = new Date();
      if (now.getMinutes() !== currentTimeOne.getMinutes()) {
        setCurrentTimeOne(now);
      }
    }, 1000);

    return () => clearInterval(interval);
  }, [currentTimeOne]);


  const handleMakeToast = (type, text) => {
    if (makeToast) {
      makeToast(type, text);
    }
  };

  useEffect(() => {

    // Convert selectedTime to local time
    const localSelectedTime =  new Date(selectedTime);

    localSelectedTime.setMinutes(localSelectedTime.getMinutes() - durationReFill)

    // Getting local date and time when selectedTime changes
    const year = localSelectedTime.getFullYear();
    const month = String(localSelectedTime.getMonth() + 1).padStart(2, '0');
    const day = String(localSelectedTime.getDate()).padStart(2, '0');
    const hour = String(localSelectedTime.getHours()).padStart(2, '0');
    const minute = String(localSelectedTime.getMinutes()).padStart(2, '0');
    const second = String(localSelectedTime.getSeconds()).padStart(2, '0');

    // Formatted date and time strings
    const formattedDate = `${year}-${month}-${day}`;
    const formattedTime = `${hour}:${minute}:${second}`;

    setStartDate(formattedDate);
    setStartTime(formattedTime);
    setEndTimeDisplay(getEndTime());
    const startTimeDate = new Date(`${formattedDate}T${startTime}`);
    const formattedStartTime = startTimeDate.toLocaleTimeString('en-US', { hour: 'numeric', minute: '2-digit', hour12: timeFormatAmPm });
    setStartTimeDisplay(formattedStartTime)
    if (showChargerTime) {
      const formattedStartTimeChargerTime = startTimeDate.toLocaleTimeString('en-US', { hour: 'numeric', minute: '2-digit', hour12: timeFormatAmPm, timeZone: locationTimezone });
      setStartTimeDisplayChargerTime(formattedStartTimeChargerTime)

      setStartDateDisplayChargerTime(
        new Date(`${formattedDate} ${formattedTime}`).toLocaleString('en-US', {
          day: 'numeric',
          month: 'short', // Displays abbreviated month (e.g., Jan, Feb)
          year: 'numeric',

          timeZone: locationTimezone // Use the specific timezone
        })
      );
      setEndTimeDisplayChargerTime(getEndTime(locationTimezone))
    }

  }, [selectedTime, startTime, durationReFill, duration]);

  useEffect(() => {
    setDuration("");
    setSelectedCharger("");
    setAvailableChargers([]);
    setAvailableFreeChargers([]);
    setDurationReFill(0);
    setStartInstantly(quickStart);
    setBookingSlotAvailability(true)
    setBookingSlotConflictShared(false)
  }, [selectedTime]);



  useEffect(() => {
    setSelectedCharger("");
  }, [trigger])

  useEffect(() => {
    const filteredChargers = chargersData.filter(charger => !charger.nonReservable);
    setChargers(filteredChargers);
  }, [chargersData]);



  useEffect(() => {
    const filteredBookings = bookingsData.filter(booking => !booking.charger?.charger?.nonReservable);
    setBookings(filteredBookings);
    getLockedAmount();
  }, [bookingsData]);



  const getLockedAmount = async () => {
    try {
      const lockedAmt = await BreathAPIs.getTotalFutureEstimate();
      setLockedAmout(lockedAmt.data)
    } catch (error) {
      console.log("... ")
    }

  }

  const getEndTime = (timezone = null) => {
    const durationAsInt = parseInt(duration, 10);

    if (isNaN(durationAsInt)) {
      return "";
    }

    const localSelectedTime = new Date(new Date(selectedTime).toLocaleString('en-US', { timeZone: timezone ? timezone : undefined }));
    const localPrevSelectedTime = new Date(new Date(selectedTime).toLocaleString('en-US', { timeZone: timezone ? timezone : undefined }));

    localSelectedTime.setMinutes(localSelectedTime.getMinutes() + durationAsInt);
    const endTimeString = new Intl.DateTimeFormat('en-US', {
      hour: 'numeric',
      minute: '2-digit',
      hour12: timeFormatAmPm,
    }).format(localSelectedTime);

    const dayIs = localSelectedTime.getDate() > localPrevSelectedTime.getDate() ? ' (+1)' : '';

    return `${'- '}${endTimeString}${dayIs}`;
  };





  // Combine date and time
  let startDateTime = new Date(selectedTime)
  // const costPerMinute = 4.2;
  // Calculate end time
  const endDateTime = new Date(startDateTime);
  const totalMinutesForDuration = (parseFloat(duration, 10)); // Convert duration to minutes
  const hoursToAdd = Math.floor(totalMinutesForDuration / 60); // Whole hours
  const minutesToAdd = totalMinutesForDuration % 60; // Remaining minutes

  endDateTime.setHours(endDateTime.getHours() + hoursToAdd);
  endDateTime.setMinutes((endDateTime.getMinutes() + parseFloat(durationReFill, 10)) + minutesToAdd);


  // function convertToChargerTimeZone(utcDate, timeZone) {
  //   // Ensure utcDate is a Date object
  //   const date = new Date(utcDate);

  //   // Use Intl.DateTimeFormat to convert the date to the specified time zone
  //   const options = {
  //     timeZone: timeZone,
  //     hour12: false, // 24-hour format
  //     year: 'numeric',
  //     month: '2-digit',
  //     day: '2-digit',
  //     hour: '2-digit',
  //     minute: '2-digit',
  //     second: '2-digit',
  //   };

  //   const formatter = new Intl.DateTimeFormat('en-US', options);
  //   const parts = formatter.formatToParts(date);

  //   // Extracting the individual date/time components
  //   const result = {};
  //   parts.forEach(({ type, value }) => {
  //     result[type] = value;
  //   });

  //   // Ensure the format is compatible with Date constructor (YYYY-MM-DDTHH:mm:ss)
  //   const formattedDate = `${result.year}-${result.month}-${result.day}T${result.hour}:${result.minute}:${result.second}`;

  //   // Return the new Date object in the specified time zone
  //   return new Date(formattedDate);
  // }
  // function getTargetZoneOffset(timeZone, date = new Date()) {
  //   try {


  //     const formatter = new Intl.DateTimeFormat('en-US', {
  //       timeZone,
  //       hour12: false,
  //       year: 'numeric',
  //       month: '2-digit',
  //       day: '2-digit',
  //       hour: '2-digit',
  //       minute: '2-digit',
  //       second: '2-digit'
  //     });

  //     const parts = formatter.formatToParts(date);
  //     const hourPart = parts.find(part => part.type === 'hour');
  //     const minutePart = parts.find(part => part.type === 'minute');

  //     const hour = parseInt(hourPart.value, 10);
  //     const minute = parseInt(minutePart.value, 10);

  //     // Get UTC time
  //     const utcHour = date.getUTCHours();
  //     const utcMinute = date.getUTCMinutes();

  //     const hourOffset = hour - utcHour;
  //     const minuteOffset = minute - utcMinute;

  //     return (hourOffset * 60) + minuteOffset; // Offset in minutes
  //   } catch (e) {
  //     console.error('Failed to calculate timezone offset:', e);
  //     return 0;
  //   }
  // }


  // const convertToTimezone = (timeString, timezone, dateFactor) => {
  //   const [startTime, endTime] = timeString.split('-');

  //   const convertTime = (time, timeZone) => {
  //     const [hours, minutes, seconds] = time.split(':');
  //     let date = new Date(dateFactor);
  //     let dateFactorDate = date.getDate();

  //     date.setHours(hours, minutes, seconds, 0);

  //     let offset = getTargetZoneOffset(timezone, date)
  //     date = new Date(date.getTime() + (offset * 60 * 1000))
  //     date.setDate(dateFactorDate)

  //     return date;
  //   };

  //   let startDateInTimezone = convertTime(startTime);
  //   let endDateInTimezone = convertTime(endTime);

  //   return { rangeStart: startDateInTimezone, rangeEnd: endDateInTimezone };
  // };

  // const bookingDurationCalculation = (startDateTimeCompensated, endDateTimeCompensated, rangeStart, rangeEnd, costPerMin) => {
  //   let dynamicTime = 0;
  //   let estimateAmount = 0;

  //   //condition 1 - rangeStart<startDateTime<rangeEnd && rangeStart < endDateTime > rangeEnd // span over start time
  //   if (rangeStart <= startDateTimeCompensated && startDateTimeCompensated <= rangeEnd && rangeStart <= endDateTimeCompensated && endDateTimeCompensated >= rangeEnd) {
  //     dynamicTime = (new Date(rangeEnd) - new Date(startDateTimeCompensated)) / (1000 * 60);
  //     estimateAmount = (costPerMin * dynamicTime)
  //   }
  //   //condtion 2 - rangeStart > startDateTime < rangeEnd && rangeStart < endDateTime < rangeEnd // span over end time
  //   else if (rangeStart >= startDateTimeCompensated && startDateTimeCompensated <= rangeEnd && rangeStart <= endDateTimeCompensated && endDateTimeCompensated <= rangeEnd) {
  //     dynamicTime = (new Date(endDateTimeCompensated) - new Date(rangeStart)) / (1000 * 60);
  //     estimateAmount = (costPerMin * dynamicTime)
  //   }
  //   //condition 3 - rangeStart > startDateTime < rangeEnd && rangeStart < endDateTime > rangeEnd // range within start and end
  //   else if (rangeStart >= startDateTimeCompensated && startDateTimeCompensated <= rangeEnd && rangeStart <= endDateTimeCompensated && endDateTimeCompensated >= rangeEnd) {
  //     dynamicTime = (new Date(rangeEnd) - new Date(rangeStart)) / (1000 * 60);
  //     estimateAmount = (costPerMin * dynamicTime)
  //   }

  //   else {
  //     console.log(" .... ")
  //   }

  //   return { calcEstimateAmount: estimateAmount, calcDynamicTime: dynamicTime }
  // }

  // const dynamicRangeFreeSlotCheck = (range1, range2, applicableDynamicRange, range1Index, range2Index) => {

  //   let updatedTimeRange = '';
  //   let rangeFree = null;
  //   let rangePaid = null;
  //   let index = null;
  //   let applicableRangesModified = applicableDynamicRange;
  //   if (range1.freeCharging === true && range2.freeCharging === true) {
  //     return applicableRangesModified
  //   }
  //   if (range1.freeCharging === true) {
  //     rangeFree = range1.timeRange
  //     rangePaid = range2.timeRange
  //     index = range2Index;
  //   } else if (range2.freeCharging === true) {
  //     rangeFree = range2.timeRange
  //     rangePaid = range1.timeRange
  //     index = range1Index;
  //   } else {
  //     return applicableRangesModified
  //   }
  //   let [rfStart, rfEnd] = rangeFree.split("-")
  //   let [rpStart, rpEnd] = rangePaid.split("-")
  //   const convertTime = (time) => {
  //     const [hours, minutes, secondsWithMillis] = time.split(':');
  //     const [seconds, milliseconds] = secondsWithMillis.split('.');
  //     let date = new Date();
  //     date.setHours(hours, minutes, seconds, milliseconds);
  //     return date;
  //   };
  //   rfStart = convertTime(rfStart);
  //   rfEnd = convertTime(rfEnd);
  //   rpStart = convertTime(rpStart);
  //   rpEnd = convertTime(rpEnd);
  //   if (rfEnd <= rfStart) {
  //     rfEnd.setDate(rfEnd.getDate() + 1)
  //   }
  //   if (rpEnd <= rpStart) {
  //     rpEnd.setDate(rpEnd.getDate() + 1)
  //   }

  //   if ((rpStart <= rfStart && rpEnd >= rfStart) && (rpStart <= rfEnd && rpEnd <= rfEnd)) {
  //     //Span over free time start Action - paid slot end time = free slot start time - 1 ms
  //     rpEnd = new Date(rfStart.getTime() - 1)
  //     updatedTimeRange = `${convertToTimeString(rpStart)}-${convertToTimeString(rpEnd)}`
  //     applicableRangesModified[index].timeRange = updatedTimeRange;

  //   } else if ((rpStart >= rfStart && rpEnd >= rfStart) && (rpStart <= rfEnd && rpEnd >= rfEnd)) {
  //     // Span over free end time - Action  - paid slot start time = free end time + 1
  //     rpStart = new Date(rfEnd.getTime() + 1)
  //     updatedTimeRange = `${convertToTimeString(rpStart)}-${convertToTimeString(rpEnd)}`
  //     applicableRangesModified[index].timeRange = updatedTimeRange;

  //   } else if ((rpStart >= rfStart && rpEnd >= rfStart) && (rpStart <= rfEnd && rpEnd <= rfEnd)) {
  //     //Paid slot within free slot - Action Remove paid slot 
  //     updatedTimeRange = `${convertToTimeString(rpStart)}-${convertToTimeString(rpStart)}`
  //     applicableRangesModified[index].timeRange = updatedTimeRange;
  //     applicableRangesModified[index].rate = 0

  //   } else if ((rpStart <= rfStart && rpEnd >= rfStart) && (rpStart <= rfEnd && rpEnd >= rfEnd)) {
  //     //Free slot within paid slot Action - Split into two slots - 1) rpStart - rfStart-1 - 2) rfEnd+1 - rpEnd
  //     let tempStart = rpStart;
  //     let tempEnd = rpEnd;
  //     let tempSlot = { ...applicableRangesModified[index] }
  //     // slot 1
  //     rpEnd = new Date(rfStart.getTime() - 1)
  //     updatedTimeRange = `${convertToTimeString(rpStart)}-${convertToTimeString(rpEnd)}`
  //     applicableRangesModified[index].timeRange = updatedTimeRange;
  //     //slot 2
  //     tempStart = new Date(rfEnd.getTime() + 1);
  //     updatedTimeRange = `${convertToTimeString(tempStart)}-${convertToTimeString(tempEnd)}`
  //     tempSlot.timeRange = updatedTimeRange;
  //     applicableRangesModified.push(tempSlot)

  //   } else {
  //     console.log("   ....   ")
  //   }

  //   return applicableRangesModified
  // }

  // function convertToTimeString(timestamp) {
  //   let updatedDate = timestamp
  //   const utcHours = updatedDate.getHours().toString().padStart(2, '0');
  //   const utcMinutes = updatedDate.getMinutes().toString().padStart(2, '0');
  //   const utcSeconds = updatedDate.getSeconds().toString().padStart(2, '0');
  //   const utcMilliseconds = updatedDate.getMilliseconds().toString().padStart(3, '0');
  //   return `${utcHours}:${utcMinutes}:${utcSeconds}.${utcMilliseconds}`;
  // }

  // const calculateEstimatedAmount = (time = duration) => {


  //   let endDateTimeCompensated =  new Date(new Date(startDateTime).getTime()+(time*60*1000));

  //   let startDateTimeCompensated =  new Date(startDateTime);

  //   endDateTimeCompensated = new Date(endDateTimeCompensated.setMinutes(endDateTimeCompensated.getMinutes() - 10))

  //   let estimateAmount = 0

  //   let costPerMin = 0


  //   let selectedChargerData = isBookingNonRes ? selectedChargerForNonRes : chargers[0]
  //   let rate = isCustomEnergyRateForSelectedLocation ? parseFloat(customEnergyRate) : ( selectedChargerData ? selectedChargerData.rate.price_components.price : 0)
  //   let taxPercent = selectedChargerData ? selectedChargerData.rate.price_components.tax : 0
  //   let dynamicTime = 0
  //   let normalRateDuration = (endDateTimeCompensated - startDateTimeCompensated) / (1000 * 60);
    
  //   if (selectedChargerData.rateType === "fixed" || isCustomEnergyRateForSelectedLocation) {
  //     costPerMin = (rate * 12) / 60;
  //     estimateAmount = costPerMin * (((parseFloat(time, 10) + parseFloat(durationReFill, 10)) - 10));
  //     return { estimateAmount: (estimateAmount + (estimateAmount * (taxPercent / 100))), normalRate: rate } // add tax
  //   }
  //   let timezone = locationData[0].timezone;
  //   startDateTimeCompensated = convertToChargerTimeZone(startDateTimeCompensated, timezone)
  //   endDateTimeCompensated = convertToChargerTimeZone(endDateTimeCompensated, timezone)
  //   let applicableDynamicRangesStart = [];
  //   let applicableDynamicRangesEnd = [];
  //   let applicableDynamicRangesCorrected = []; //TO adjust for free time slots

  //   let applicableDynamicRanges = selectedChargerData.dynamicRates.filter(
  //     (rate) => {
  //       return (rate.applicableDays[startDateTimeCompensated.getDay()] === 1 || rate.applicableDays[endDateTimeCompensated.getDay()] === 1)
  //     }
  //   )
  //   let newApplicableDynamicRanges = [];
  //   let applicableDynamicRangeCurrent = JSON.parse(JSON.stringify(applicableDynamicRanges)) //To create a copy of the existing array
  //   applicableDynamicRanges.length > 1 ?
  //     applicableDynamicRanges.forEach((range, index) => {
  //       for (let i = index + 1; i <= applicableDynamicRanges.length - 1; i++) {
  //         newApplicableDynamicRanges = dynamicRangeFreeSlotCheck(range, applicableDynamicRanges[i], applicableDynamicRangeCurrent, index, i)
  //       }

  //     }) : newApplicableDynamicRanges = JSON.parse(JSON.stringify(applicableDynamicRanges))

  //   newApplicableDynamicRanges.filter(
  //     (rate) => {
  //       if (rate.applicableDays[startDateTimeCompensated.getDay()] === 1) {
  //         applicableDynamicRangesStart.push(rate)
  //       }
  //       if (rate.applicableDays[endDateTimeCompensated.getDay()] === 1) {
  //         applicableDynamicRangesEnd.push(rate)
  //       }
  //       return (rate.applicableDays[startDateTimeCompensated.getDay()] === 1 || rate.applicableDays[endDateTimeCompensated.getDay()] === 1)
  //     }
  //   )

  //   if (startDateTimeCompensated.getDay() === endDateTimeCompensated.getDay()) {
  //     newApplicableDynamicRanges.forEach(element => {
  //       let { rangeStart, rangeEnd } = convertToTimezone(element.timeRange, timezone, startDateTimeCompensated);
  //       costPerMin = (element.rate * 12) / 60;


  //       //condtion 4 - rangeStart <startDateTime < rangeEnd && rangeStart < endDateTime < rangeEnd  // range encompassing the start and end
  //       if (rangeStart <= startDateTimeCompensated && startDateTimeCompensated <= rangeEnd && rangeStart <= endDateTimeCompensated && endDateTimeCompensated <= rangeEnd) {
  //         dynamicTime = (new Date(endDateTimeCompensated) - new Date(startDateTimeCompensated)) / (1000 * 60);
  //         estimateAmount = costPerMin * dynamicTime
  //         normalRateDuration = 0;
  //         return { estimateAmount: (estimateAmount + (estimateAmount * (taxPercent / 100))), applicableDynamicRanges: applicableDynamicRanges, rateType: selectedChargerData.rateType, normalRate: rate }
  //       }

  //       let { calcEstimateAmount, calcDynamicTime } = bookingDurationCalculation(startDateTimeCompensated, endDateTimeCompensated, rangeStart, rangeEnd, costPerMin)
  //       estimateAmount += calcEstimateAmount;
  //       normalRateDuration -= calcDynamicTime
  //     });
  //   }
  //   else {
  //     let result = null
  //     // Booking Span
  //     // Booking duration split into two startTime - startDateEndTime and endDateStartTIme - endTime
  //     // Booking part current day
  //     applicableDynamicRangesStart.forEach(element => {
  //       let { rangeStart, rangeEnd } = convertToTimezone(element.timeRange, timezone, startDateTimeCompensated);
  //       costPerMin = (element.rate * 12) / 60;
  //       let startTimeDayEnd = new Date(new Date(startDateTimeCompensated).setHours(23, 59, 59, 999))
  //       result = bookingDurationCalculation(startDateTimeCompensated, startTimeDayEnd, rangeStart, rangeEnd, costPerMin)
  //       estimateAmount += result.calcEstimateAmount;
  //       normalRateDuration -= result.calcDynamicTime
  //     });

  //     //Booking part next day
  //     applicableDynamicRangesEnd.forEach(element => {
  //       let { rangeStart, rangeEnd } = convertToTimezone(element.timeRange, timezone, endDateTimeCompensated);
  //       costPerMin = (element.rate * 12) / 60;
  //       let endTimeDayStart = new Date(new Date(endDateTimeCompensated).setHours(0, 0, 0, 0))
  //       result = bookingDurationCalculation(endTimeDayStart, endDateTimeCompensated, rangeStart, rangeEnd, costPerMin)
  //       estimateAmount += result.calcEstimateAmount;
  //       normalRateDuration -= result.calcDynamicTime
  //     });
  //   }
  //   costPerMin = (rate * 12) / 60;
  //   estimateAmount += costPerMin * normalRateDuration;
  //   return { estimateAmount: (estimateAmount + (estimateAmount * (taxPercent / 100))), applicableDynamicRanges: applicableDynamicRanges, rateType: selectedChargerData.rateType, normalRate: rate }
  // }



  const formatDate = (dateString, type = "long") => {
    const date = new Date(dateString);
    const options = { day: 'numeric', month: type, year: 'numeric' };
    return date.toLocaleDateString(undefined, options);
  }

  const checkSlotAvailable = (listUsedChargers) => {

    //Filter bookings for the selected charger and date
    const existingBookings = bookings.filter(
      (b) =>
        (b.charger._id === selectedCharger || listUsedChargers) &&
        (
          (new Date(b.startTime) < endDateTime && new Date(b.endTime) > startDateTime) ||
          (new Date(b.endTime) > startDateTime && new Date(b.startTime) < endDateTime)
        )
    );
    let usedChargers = [];
    let isConflictWithSharedTime = false
    bookedSlots.map((slots) => {
      // if(slots.id === selectedCharger){
      slots.bookedSlots.map((booking) => {
        if ((new Date(booking.start).getTime() <= startDateTime.getTime() && startDateTime.getTime() < new Date(booking.end).getTime()) ||
          (new Date(booking.start).getTime() < endDateTime.getTime() && endDateTime.getTime() <= new Date(booking.end).getTime()) ||
          (startDateTime.getTime() <= new Date(booking.start).getTime() && new Date(booking.end).getTime() <= endDateTime.getTime())) {
          // setBookingSlotConflictShared(true)
          // setBookingSlotConflictShared(true)
          isConflictWithSharedTime = true
          usedChargers.push({ _id: slots.id })
        }
      })

    })
    for (let booking of existingBookings) {
      if (
        (new Date(booking.startTime).getTime() <= startDateTime.getTime() && startDateTime.getTime() < new Date(booking.endTime).getTime()) ||
        (new Date(booking.startTime).getTime() < endDateTime.getTime() && endDateTime.getTime() <= new Date(booking.endTime).getTime()) ||
        (startDateTime.getTime() <= new Date(booking.startTime).getTime() && new Date(booking.endTime).getTime() <= endDateTime.getTime())
      ) {
        if (listUsedChargers) {
          usedChargers.push(booking.charger);
        }
        else {
          handleMakeToast("error", "Booking conflicts with an existing booking.");
          return false;
        }

      }
    }
    if (!isConflictWithSharedTime) {
      setBookingSlotConflictShared(false)
      // return usedChargers
    }
    if (listUsedChargers) {
      return usedChargers;
    }
    else {
      return true;
    }
  }

  const checkPreviousSlotAvailable = () => {
    let usedChargers = [];

    const _15minBeforeSelected = new Date(selectedTime);
    _15minBeforeSelected.setMinutes(_15minBeforeSelected.getMinutes() - 15)

    for (let booking of bookings) {
      if (
        (new Date(booking.startTime).getTime() <= _15minBeforeSelected.getTime() && _15minBeforeSelected.getTime() < new Date(booking.endTime).getTime()) ||
        (new Date(booking.startTime).getTime() < endDateTime.getTime() && endDateTime.getTime() <= new Date(booking.endTime).getTime()) ||
        (_15minBeforeSelected.getTime() <= new Date(booking.startTime).getTime() && new Date(booking.endTime).getTime() <= endDateTime.getTime())
      ) {
        usedChargers.push(booking.charger);
      }
    }

    if (chargersData?.length > usedChargers?.length) {
      return true;
    }
    else {
      return false;
    }
  }

  function getTimesBetween(start, end, interval, AmPm = false) {
    let startTime = new Date(start);
    let endTime = new Date(end);
    let times = [];

    const currentTime = new Date();

    if (!(currentTime >= startTime && currentTime <= endTime)) {
      return times;
    }
    startTime.setMinutes(Math.floor(startTime.getMinutes() / interval) * interval);

    while (startTime < endTime) {
      if (currentTime < startTime) {
        times.push(formatTime(startTime, endTime, AmPm));
      }
      startTime.setMinutes(startTime.getMinutes() + interval);
    }

    times.push(formatTime(startTime, endTime, AmPm));
    return times;
  }

  function formatTime(date, endTime, AmPm = false) {
    let hours = date.getHours();
    let minutes = date.getMinutes();
    let period = '';
    if (AmPm) {
      period = hours >= 12 ? 'PM' : 'AM';
      hours = hours % 12 || 12;
    }

    hours = hours < 10 ? '0' + hours : hours;
    minutes = minutes < 10 ? '0' + minutes : minutes;

    // Calculate minutes from end time
    const diffMs =  Math.abs(endTime - date);
    const diffMins = Math.floor(diffMs / 60000); // Calculate difference in minutes


    return { time: `${hours}:${minutes} ${period}`, diffMins };
  }

  function handleExtraTime() {
    const previousSlotAvailable = checkPreviousSlotAvailable();
    if (previousSlotAvailable) {
      const _15minBeforeSelected = new Date(selectedTime);
      _15minBeforeSelected.setMinutes(_15minBeforeSelected.getMinutes() - 15);
      const SelectedTime = new Date(selectedTime);
      const extraTimeListData = getTimesBetween(_15minBeforeSelected, SelectedTime, 5, timeFormatAmPm)
      setExtraTimeList(extraTimeListData);
      setDurationReFill(extraTimeListData.length ? (extraTimeListData.some(item => item.diffMins === durationReFill) ? durationReFill : 0) : 0);
    }
    else {
      setExtraTimeList([]);
      setDurationReFill(0);
    }
  }

  useEffect(() => {
    handleExtraTime();
    setInstantTime(formatTime(new Date(), new Date(selectedTime), timeFormatAmPm));
  }, [duration, currentTimeOne, selectedTime]);

//   useEffect(() => {
//     const handleDurationChange = () => {
//       const usedChargers = checkSlotAvailable(true);
//       const chargersList = chargers.filter(
//         charger => !usedChargers.some(usedCharger => usedCharger._id.toString() === charger._id)
//       );
//       setAvailableChargers(chargersList);

//       const availableFreeChargerList = chargersList.filter(
//         charger => charger.freeChargingComponent.isFreeCharging === true
//       );

//       setAvailableFreeChargers(availableFreeChargerList);

//       const getRandomChargerId = (chargersArray) => {
//         const randomIndex = Math.floor(Math.random() * chargersArray.length);
//         return chargersArray[randomIndex]._id;
//       }

//       const getSortedChargerId = (chargersArray) => {
//         // Finding the charger with the least utilizationScore
//         const selectedCharger = chargersArray.reduce((prev, curr) => {
//           return (prev.utilizationScore < curr.utilizationScore) ? prev : curr;
//         });

//         return selectedCharger._id; // Returning the charger id with the least utilizationScore
//       }


//       if (chargersList.length > 0) {
//         locationData[0].chargerAllocationConfiguration === 'Random' ? setSelectedCharger(getRandomChargerId(chargersList)) : setSelectedCharger(getSortedChargerId(chargersList));
//         setBookingSlotAvailability(true)
//       } else {
//         setSelectedCharger("");
//         if (duration.length > 0) {
//           setBookingSlotAvailability(false)
//         }
//       }
//       if (isBookingNonRes) {
//         setSelectedCharger(selectedChargerForNonRes?.id)
//       }
//     };
//     handleDurationChange();

//     duration && setMinimumBalanceAvailable(checkMinimumBalance(lockedAmount))

//   }, [duration, startTime]);


  
  useEffect(()=>{
    if(isBookingNonRes){
      if(!isAutoPayEnabled){
        let minimumBalanceAvailable;
        for (let i=locationData[0].maxChargeDuration * 60 ;  i>=(locationData[0]?.minChargeDuration * 60) ?? 15 ; i-= 15) {
          setDuration(i)
          minimumBalanceAvailable = checkMinimumBalance(lockedAmount, i)
          if(minimumBalanceAvailable){
            setNonResBookingAllowed(true)
            setMinimumBalanceAvailable(true)
            break
          }
        }
        if(!minimumBalanceAvailable){
          setNonResBookingAllowed(false)
        }
      }else{
        setDuration(locationData[0].maxChargeDuration*60)
        checkMinimumBalance(lockedAmount, locationData[0].maxChargeDuration*60)
        setNonResBookingAllowed(true)
      }
    }
  },[lockedAmount, selectedTime, balance, isCustomEnergyRateForSelectedLocation, isFreeChargingForSelectedLocation])



  const handleAnimationRender = () => {
    if (duration !== "" && bookingSlotAvailability && minimumBalanceAvailable) {
      const timer = setTimeout(() => {
        setRenderTickMark(true);
      }, 200);

      // Clean up the timer
      return () => clearTimeout(timer);
    } else {
      setRenderTickMark(false);
    }
  }

  useEffect(() => {
    handleAnimationRender()
  }, [duration, startTime, bookingSlotAvailability, minimumBalanceAvailable])





  useEffect(() => {
      const handleDurationChange = () => {
        let minimumBalanceAvailableForSelectedDuration = checkMinimumBalance(lockedAmount, (locationData[0].maxChargeDuration * 60), startInstantly, selectedCharger)
      };
      handleDurationChange();
  
      duration && setMinimumBalanceAvailable(checkMinimumBalance(lockedAmount))
  
    }, [duration, startTime, startInstantly, estimateAmount]);
  



  const checkMinimumBalance = (lockedAmount = 0, time = duration) => {
    
    let onGoingBookingEstimate = Helper.calculateEstimatedAmount(time, startDateTime, endDateTime, selectedCharger, isBookingNonRes, isCustomEnergyRateForSelectedLocation, customEnergyRate, selectedChargerForNonRes, chargers, locationData, durationReFill, null, userAvgPower, false, locationData[0]?.gracePeriodInMinutes ?? 10);
    
    if(isBookingNonRes){
      isFreeChargingForSelectedLocation ? setEstimateAmount(0) : setEstimateAmount(onGoingBookingEstimate.estimateAmount)

      isCustomEnergyRateForSelectedLocation ? sestDynamicRanges([]) : sestDynamicRanges(onGoingBookingEstimate.applicableDynamicRanges);
      setRateType(onGoingBookingEstimate.rateType);
      setNormalRate(onGoingBookingEstimate.normalRate)
      setEstimateSplit(onGoingBookingEstimate.rateSplit)

      // setEstimateAmount(onGoingBookingEstimate.estimateAmount)
    }
    if(isFreeChargingForSelectedLocation){
      return true
    }
    // Guests pay via a per-booking Stripe hold after booking, not the shared
    // pool account's wallet, so its balance/autopay state doesn't apply to them.
    if(isGuest){
      return true
    }
    let minimumBalance = parseFloat(lockedAmount) + parseFloat(onGoingBookingEstimate.estimateAmount)
    if(isAutoPayEnabled){
      return true
    }
    if (parseFloat(balance) < parseFloat(minimumBalance)) {
      return false;
    }
    return true
  }

  const submitBooking = async (bookingData, bookingCreatedAt, guestPaymentIntentId = null) => {
    try {
      setIsSubmitting(true);
      const res = await BreathAPIs.createNonResBooking(bookingData, bookingCreatedAt, guestPaymentIntentId);
      setTrigger(!trigger);
      handleNewBooking(bookingData);
      handleMakeToast("success", res.data?.msg || res.data);
    } catch (err) {
      console.error("Error in makeBooking api call:", err);
      refetchBookings();
      if (err.response) {
        console.error("Response data:", err.response.data);
        // Check for 400 status code and handle it specifically
        if (err.response.status === 400) {
          handleMakeToast("error", "Bad request: " + (err.response.data.errors.msg || "An error occurred"));
        } else if (err.response.status === 402) {
          handleMakeToast("error", err.response.data.errors.msg || "An error occurred");
        }
        else {
          handleMakeToast("error", err.response.data.errors.msg || "An error occurred");
        }
      } else if (err.request) {
        console.error("No response received:", err.request);
        handleMakeToast("error", "No response received from the server");
      } else {
        console.error("Error setting up the request:", err.message);
        handleMakeToast("error", "An error occurred while processing your request");
      }
    } finally {
      setIsSubmitting(false);
    }
  }

  const handleSubmit = async (e) => {
    e.preventDefault();


    let bookable = true;
    const bookingData = {
      nonReservable: isBookingNonRes ? true : false,
      charger: isBookingNonRes ? selectedChargerForNonRes?.id  : selectedCharger,
      connector: selectedChargerForNonRes.connectorID,
      startTime: startDateTime,
      endTime: endDateTime,
      endTimeScheduled:endDateTime,
      date: startDateTime.toISOString().split("T")[0], // get the date part in yyyy-mm-dd format
      user: userID,
      bookingType: isFreeChargingForSelectedLocation || estimateAmount === 0 ? 'free' : "paid",
      time: new Date(),
      unUtilizedTime: {
        total: (new Date(endDateTime) - new Date(startDateTime)) / 1000,
        freeTime: 0,
        paidTime: (new Date(endDateTime) - new Date(startDateTime)) / 1000
      },
      estimateAmount: estimateAmount,
      dynamicRates: rateType === "dynamic" ? dynamicRanges : [],
      normalRate: normalRate,
      rateType: rateType,
      bookingCreationSource: "webApp",
    };

    if (checkSlotAvailable(false) === false) {

      return;
    }


    bookable = checkMinimumBalance(lockedAmount)

    const bookingCreatedAt = new Date();

    // Guests must authorize a card hold before the booking is created - the
    // modal calls submitBooking itself once the hold succeeds.
    if (isGuest && estimateAmount > 0) {
      setGuestPaymentBooking({ bookingData, bookingCreatedAt });
      return;
    }

    await submitBooking(bookingData, bookingCreatedAt);
  }

  function chargeDuration() {
    if (duration === "") {
      return '(booking time - 10 minutes)';
    }
    let totalMinutes = parseFloat(duration, 10);
    totalMinutes -= totalMinutes >= 30 ? locationData[0]?.gracePeriodInMinutes ?? 10 : 5;;
    totalMinutes += durationReFill;
    let outputHours = Math.floor(totalMinutes / 60);
    let outputMinutes = totalMinutes % 60;
    let formattedOutput = "";
    if (outputHours > 0) {
      formattedOutput += outputHours + " hour";
      if (outputHours > 1) {
        formattedOutput += "s";
      }
      formattedOutput += ", ";
    }
    formattedOutput += outputMinutes + " minute";
    if (outputMinutes !== 1) {
      formattedOutput += "s";
    }
    return formattedOutput;
  }

  function formatRateRangeTime(rangeStart, rangeEnd) {
    const opts = { hour: 'numeric', minute: '2-digit', hour12: timeFormatAmPm };
    const startLabel = new Date(rangeStart).toLocaleTimeString('en-US', opts);
    const endLabel = new Date(rangeEnd).toLocaleTimeString('en-US', opts);
    return `${startLabel} - ${endLabel}`;
  }

  function formatDurationMinutes(duration) {
    if (duration === "") {
      return '';
    }
    let totalMinutes = parseFloat(duration, 10);
    let outputHours = Math.floor(totalMinutes / 60);
    let outputMinutes = totalMinutes % 60;
    return outputHours > 0 ? `${outputHours}hr ${outputMinutes}min` : `${outputMinutes}min`;
  }

  const selectedChargerDataForRegularRate = isBookingNonRes ? selectedChargerForNonRes : (selectedCharger ? chargers.find((charger) => Array.isArray(charger.connector) && charger.connector.find((conn) => String(conn._id) === String(selectedCharger))) : chargers[0]);
  const regularRatePerKwh = isCustomEnergyRateForSelectedLocation ? parseFloat(customEnergyRate) : (selectedChargerDataForRegularRate ? selectedChargerDataForRegularRate.rate.price_components.price : 0);

  const today = new Date().toISOString().split('T')[0];

  const totalDuration = (parseInt(duration) + parseInt(durationReFill));


  useEffect(() => {
    if (startInstantly) {
      setDurationReFill(formatTime(new Date(), new Date(selectedTime), timeFormatAmPm)?.diffMins + 1);
    }
    else {
      setDurationReFill(0);
    }
  }, [startInstantly, duration, currentTimeOne]);

  let connectMessage = "";
  if(connectorStatus === "Available"){
    connectMessage = "Please plug-in connector to your vehicle to Initiate"
  }
  if(connectorStatus === "Finishing"){
    connectMessage = "It looks like the connector is in use. If connector is plugged in to your vehicle, please unplug and plug in again to Initiate"
  }
  let buttonElement;
  if (!isGuest && (!isPhoneVerifiedState || phoneState?.length === 0)) {
    buttonElement = (
      <button
        className={styles['button']}
        onClick={() => {
          setShowPhoneVerificationModal(true);
          // setDoesUserInput(false);
        }}
        type="button"
      >
        Verify Phone number
      </button>
    );
  } else if (minimumBalanceAvailable && nonResBookingAllowed) {
    buttonElement = (
      <ButtonCustom
        disabled={
          isSubmitting ||
          (!(instantTime?.diffMins >= 0)) ||
          !bookingSlotAvailability ||
          (!minimumBalanceAvailable && isFreeChargingForSelectedLocation === false) ||
          bookingSlotConflictShared ||
          connectorStatus !== "Preparing"
        } isLoading={isSubmitting}
        text={isSubmitting ?
          (isBookingNonRes ? "Initiating..." : 'Booking...') :
          (isBookingNonRes ? "Initiate" : 'Book')} type='submit' />
    );
  } else {
    buttonElement = (
      <button
        className={styles['button']}
        onClick={() => setWalletRechargeModal(true)}>
        Add Amount
      </button>
    );
  }

  const handleVerificationSuccess = async () =>{
  try {
    const res = await BreathAPIs.updatePhone(phoneState)
    if(res.status === 200){
      toast.success("Phone number updated successfully")
      store.dispatch(loadUser())
      setIsPhoneVerifiedstate(true)
    }
    if(res.status === 409){
      toast.warning("Phone numeber exists")
    }
    
  } catch (error) {
    if (error.response.status === 409){
      toast.warning("Phone numeber exists")
      return
    }
    toast.error("Could not verify phone number")
  }
}

  return (
    <div className="container mt-4" style={{ marginBottom: "20px" }}>
      <h2 className="text-center mb-4">{isBookingNonRes ? "Initiate Charging" : "Book your slot"}</h2>
      <div className="row justify-content-center">
        <div className="col-12 col-md-10 col-lg-10" >
          <form onSubmit={handleSubmit}>

            <div className="mb-3">
              <label className="form-label">Slot</label>
              <div className={`form-control d-flex justify-content-between align-items-center ${styles['time-slot']}`}>
                <span className={styles['slot-date']}>{formatDate(`${startDate} ${startTime}`)}</span>
                <span className={styles['slot-date-sm']}>{formatDate(`${startDate} ${startTime}`)}</span>
                <span className='btn btn-primary btn-sm pe-none'>{startTimeDisplay} {endTimeDisplay}</span>
              </div>

              {(showChargerTime && !isBookingNonRes) &&

                <div className={styles['top-charger-timezone']}>
                  <div>
                    {locationTimezone}<FaChargingStation />
                    <div className={styles['charger-time']}>
                      <span>{formatDate(startDateDisplayChargerTime)} </span>
                      <span>{startTimeDisplayChargerTime} {endTimeDisplayChargerTime}</span>
                    </div>
                  </div>

                </div>
              }





              {isUserTester &&
                <input type='number' min={0} value={durationReFill} className="form-control" onChange={(e) => { setDurationReFill(e.target.value) }} />

              }
            </div>



            {(extraTimeList.length && !isBookingNonRes) ? <div className={styles['duration-re-fill']}>

              <div className={styles['re-fill-message']}>Would you like to start earlier?</div>

              <button type='button' onClick={() => setStartInstantly(!startInstantly)} className={`${styles['btn-instant-start']} ${startInstantly ? styles['active'] : undefined}`}>Charge</button>

              {!startInstantly && extraTimeList.length > 1 ? <div className={styles['button-grp']}>
                {extraTimeList.map((time, index) => (
                  <button className={time.diffMins === durationReFill ? styles['active'] : undefined} type='button' key={index + '-' + time.time} onClick={() => setDurationReFill(time.diffMins)}>{time.time}</button>
                ))}
              </div> : null}

              {duration ? <div className={styles['total-duration']}>Total Duration: <b>{parseInt(totalDuration / 60)}h : {totalDuration % 60}m</b></div> : null}
            </div> : <></>}



            <div className="mb-3">
              {(isBookingNonRes && !nonResBookingAllowed ) ? <></> : <label className="form-label">Duration</label>}
              { isBookingNonRes ? (
                  nonResBookingAllowed ? 
                  <HourMinuteSelector onChange={(val) => { setDuration(val); 
                    // setDoesUserInput(true)
                   }} defaultMinute={duration} maxSelectionInMin={locationData[0]?.maxChargeDuration * 60} source='bookingForm' minSelectionInMinutes={(locationData[0]?.minChargeDuration * 60) ?? 15}></HourMinuteSelector>
                // <input
                //   type="text"
                //   value={`Upto  ${formatDurationMinutes(duration)}`}
                //   disabled
                //   className={`${styles.glassmorphic} ${styles['non-resinput-text']}`}
                // />
                 : <></>): 
              <select
                value={duration}
                onChange={(e) => setDuration(e.target.value)}
                className={isBookingNonRes ? `${styles.glassmorphic}` : `form-select ${styles.glassmorphic}`}
                required
                disabled={isBookingNonRes}
              >
                <option value="" disabled>
                  Select Duration
                </option>
                {userGroups.some(userGroup => userGroup.groupName === "Test-Users") ? [1 / 4, 1, 2, 3, 4, 5, 6].map((hour) => (


                  <option value={hour * 60} key={hour}>
                    {/* {hour} hour(s) */}
                    {hour === 1 / 20 ? "3 minutes" : `${hour} hour(s)`}
                  </option>
                )) :

                  Array.from({ length: locationData[0].maxChargeDuration }, (v, i) => i + 1).map((hour) => (


                    <option value={hour * 60} key={hour}>
                      {/* {hour} hour(s) */}
                      {hour === 1 / 20 ? "3 minutes" : `${hour} hour(s)`}
                    </option>
                  ))

                }
              </select> }

            </div>
            {
              isBookingNonRes && <div>
                <label className='form-label'>Selected Charger</label>
                
                <input
                  type="text"
                  value={`${selectedChargerForNonRes.title} ${selectedChargerForNonRes.noOfConnectorsInCharger !== 1 ? `- #${selectedChargerForNonRes.connectorNumber}` : ''}`}
                  disabled
                  className={`${styles.glassmorphic}`}
                  style={{ marginBottom: '10px' }}
                />

              </div>
            }
            {userGroups.some(userGroup => userGroup.groupName === "Test-Users") && <div className="mb-3">
              <label className="form-label">Select Charger</label>
              <select
                value={selectedCharger}
                onChange={(e) => setSelectedCharger(e.target.value)}
                className={`form-select ${styles.glassmorphic}`}
                required
              >
                <option value="" disabled>
                  Select Charger
                </option>
                {duration && availableChargers.map((charger) => (
                  <option value={charger._id} key={charger._id}>
                    {charger.chargerTag} 
                  </option>
                ))}
              </select>
            </div>}

            <div className="d-grid">
              {
                <div className={styles['estimated-amount']}>Estimated amount : $ {duration ? estimateAmount?.toFixed(2) : "0.00"}
                  {duration && <FaInfoCircle onClick={() => { setMoreInfo(!moreInfo) }} />}
                </div>
              }

              {
                duration && 
                <div className={`${styles['info-data']}`}>
                  <div>Charge Duration: {chargeDuration()}</div>
                  <div>Grace Period: {`${(duration + durationReFill) >= 30 ? locationData[0]?.gracePeriodInMinutes ?? 10 : 5}`} minutes, without energy delivery</div>
                    {
                      moreInfo &&
                      <>
                        <hr></hr>
                        <div className={styles.idleFeeDiv}>Idle Fee: <span className={styles.idleFeeSpan}>$ {idleFee}/min</span></div>
                        <div ><i className={styles.unutFeeDiv}>Charge for
                          <span className={styles.unutFeeSpan}>
                            <b>{parseInt((((duration + durationReFill) - ((duration + durationReFill) >= 30 ? 10 : 5)) * 0.7) / 60)}h
                              : {parseInt((((duration + durationReFill) - ((duration + durationReFill) >= 30 ? 10 : 5)) * 0.7) % 60)}m</b></span>
                          to avoid unutilized time fee </i></div>
                        {
                          ((estimateSplit?.dynamicRates?.length > 0 || estimateSplit?.normalRate > 0 || estimateSplit?.tax > 0) && estimateAmount > 0) &&
                          <>
                            <div className={styles.rateSplitTitle}>Rate Breakdown</div>
                            {estimateSplit.powerUsed > 0 &&
                              <div className={styles.idleFeeDiv}>
                                <span className={styles.rateSplitLabel}>Calculated using {estimateSplit.isUserAvgPowerUsed ? 'your average charging power' : "charger's rated power"}</span>
                                <span className={styles.rateSplitValue}>{estimateSplit.powerUsed?.toFixed(2)} kW</span>
                              </div>
                            }
                            {estimateSplit.dynamicRates.filter((range) => range.estimateInRange > 0).map((range, idx) => (
                              <div key={idx} className={styles.idleFeeDiv}>
                                <span className={styles.rateSplitLabel}>{formatRateRangeTime(range.rangeStart, range.rangeEnd)} @ $ {range.perkWhCost?.toFixed(2)}/kWh</span>
                                <span className={styles.rateSplitValue}>$ {range.estimateInRange?.toFixed(2)}</span>
                              </div>
                            ))}
                            {estimateSplit.normalRate > 0 &&
                              <div className={styles.idleFeeDiv}>
                                <span className={styles.rateSplitLabel}>Regular Rate ($ {regularRatePerKwh?.toFixed(2)}/kWh)</span>
                                <span className={styles.rateSplitValue}>$ {estimateSplit.normalRate.toFixed(2)}</span>
                              </div>
                            }
                            <div className={styles.idleFeeDiv}>
                              <span className={styles.rateSplitLabel}>Tax</span>
                              <span className={styles.rateSplitValue}>$ {(estimateSplit.tax || 0).toFixed(2)}</span>
                            </div>
                          </>
                        }
                      </>
                    }
                  </div>
              }
              
              {
                
                ((!bookingSlotAvailability || (!minimumBalanceAvailable && isFreeChargingForSelectedLocation === false) || bookingSlotConflictShared) && !isBookingNonRes) &&
                <div className={styles["unavailable-container"]}>
                  {
                    !minimumBalanceAvailable &&
                    <div>
                      <CgUnavailable className={styles['unavailable-icon']}></CgUnavailable>
                      {
                        ((duration == 60 || !bookingSlotAvailability)) ? <span className={styles['unavailable-span']}>Insufficient balance, please add amount to wallet.</span> :
                          <span className={styles['unavailable-span']}>Please add amount to wallet or select a shorter duration.</span>
                      }
                    </div>
                  }

                  {

                    (!bookingSlotAvailability || bookingSlotConflictShared) &&
                    <div>
                      <CgUnavailable className={styles['unavailable-icon']}></CgUnavailable>
                      <span className={styles['unavailable-span']}>Please change the duration or select another slot.</span>
                    </div>
                  }
                </div>
              }
              {
                (isBookingNonRes && !nonResBookingAllowed) && 
                <div className={styles["unavailable-container"]}>
                  <div>
                      <CgUnavailable className={styles['unavailable-icon']}></CgUnavailable>
                      <span className={styles['unavailable-span']}>Please enable auto pay from Profile or reload wallet.</span>
                    </div>
                </div>
              }

              {walletRechargeModal && <Modal open={walletRechargeModal} onCancel={() => { setWalletRechargeModal(!walletRechargeModal) }} footer={null}>
                <StripePayment setWalletRechargeModal={setWalletRechargeModal} amountToAdd={estimateAmount - balance >= 10 ? Math.ceil(estimateAmount - balance) : 10}/>
              </Modal>}
              {
                <PhoneVerificationModal
                  closeModal={() => setShowPhoneVerificationModal(false)}
                  onVerificationSuccess={handleVerificationSuccess}
                  modalVisible={showPhoneVerificationModal}
                  phoneNumber={phone}
                  fromBookingForm={true}
                  setPhoneState={setPhoneState}
                >
                </PhoneVerificationModal>
              }
              {guestPaymentBooking && <Modal title="Authorize Payment" open={!!guestPaymentBooking} onCancel={() => setGuestPaymentBooking(null)} footer={null} closable={false}>
                <GuestBookingPayment
                  amount={guestPaymentBooking.bookingData.estimateAmount}
                  onSuccess={(paymentIntentId) => {
                    const { bookingData, bookingCreatedAt } = guestPaymentBooking;
                    setGuestPaymentBooking(null);
                    submitBooking(bookingData, bookingCreatedAt, paymentIntentId);
                  }}
                  onCancel={() => setGuestPaymentBooking(null)}
                />
              </Modal>}

              {/* {!minimumBalanceAvailable || !nonResBookingAllowed ?
                <button className={styles['button']} onClick={() => setWalletRechargeModal(true)}>Add Amount</button>
                :
                <ButtonCustom disabled={isSubmitting || (!(instantTime?.diffMins >= 0)) || !bookingSlotAvailability || (!minimumBalanceAvailable && isFreeChargingForSelectedLocation === false) || bookingSlotConflictShared} isLoading={isSubmitting} text={isSubmitting ? (isBookingNonRes ? "Initiating..." : 'Booking...') : (isBookingNonRes ? "Initiate" : 'Book')} type='submit' />

              } */}
              {
                <div className={styles['connect-message']}>
                  {connectMessage}
                </div>
              }

              {
                buttonElement
              }
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}
BookingFormNonRes.propTypes = {
  user: PropTypes.string,
  userID: PropTypes.string,
  userGroups: PropTypes.array,
  usersFreeChargingLocations: PropTypes.array,
  location: PropTypes.array,
  balance: PropTypes.number,
  isUserTester: PropTypes.bool,
  isAutoPayEnabled: PropTypes.bool,
  timeFormatAmPm: PropTypes.bool,
  isPhoneVerified: PropTypes.bool,
  phone: PropTypes.string,
  userAvgPower: PropTypes.object  
}
const mapStateToProps = state => ({
  user: state.auth && state.auth.user ? state.auth.user.firstName : null,
  userID: state.auth && state.auth.user ? state.auth.user._id : null,
  userGroups: state.auth && state.auth.user ? state.auth.user.userGroups : [],
  location: state.auth && state.auth.user ? state.auth.user.location : null,
  usersFreeChargingLocations: state.auth && state.auth.user ? state.auth.user.freeChargingAllowedLocations : [],
  balance: state.auth && state.auth.user ? state.auth.user.wallet.coins : null,
  isUserTester: state.auth && state.auth.user ? state.auth.user.isUserTester : false,
  isAutoPayEnabled: state.auth && state.auth.user ? state.auth.user.isAutoPayEnabled : false,
  timeFormatAmPm: state.auth && state.auth.user ? state.auth.user.timeFormatAmPm : false,
  isPhoneVerified: state.auth && state.auth.user ? state.auth.user.isPhoneVerified : false,
  phone: state.auth && state.auth.user ? state.auth.user.phone : false,
  userAvgPower: state.auth && state.auth.user ? state.auth.user.avgPower : null,
  isGuest: state.auth && state.auth.user ? state.auth.user.isGuest : false,
})
export default connect(mapStateToProps, {})(BookingFormNonRes)